import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { jwtTokenInterceptor } from '@core/interceptors/jwt-token.interceptor';
import { JwtModule } from '@auth0/angular-jwt';
import { errorInterceptor } from '@core/interceptors/error.interceptor';
import { RoleService } from '@core/services/authentication/role.service';

function initializeRoles() {
  const roleService = inject(RoleService);
  return () => roleService.loadRoles();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeRoles,
      multi: true,
    },
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      })
    ),
    provideHttpClient(withInterceptors([jwtTokenInterceptor, errorInterceptor])),
    provideCharts(withDefaultRegisterables())   ,
    importProvidersFrom([JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem('jwt_token');
        }
      }
    })])
  ],
};
